import { pxToRem } from "@getbread/dough";
import { styled } from "@mui/material/styles";
import { ErrorBoundary } from "react-error-boundary";
import { FormattedMessage } from "react-intl";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import cloudImg from "../../assets/bread/cloud.svg";
import { logger } from "../../logger";
import { reloadPage } from "../../utils/helpers";
import { LinkButton } from "../shared/LinkButton";
import { HeaderText } from "../shared/SubNavBar";

const Header = styled(HeaderText)`
	font-size: ${pxToRem(36)};
	font-weight: 600;
`;

const Content = styled("div")`
	color: ${(props) => props.theme.palette.primary.main};
	margin-top: var(--space-s);
	font-size: ${pxToRem(24)};
	font-weight: 600;
`;

const Container = styled("div")`
	margin: var(--space-xxxl) var(--space-l);
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Icon = styled("img")`
	margin: var(--space-xxxl) 0;
`;

export const GenericErrorMessage = () => {
	return (
		<Container data-testid="generic-error-message">
			<Header>
				<FormattedMessage defaultMessage="Oh no!" />
			</Header>
			<Content>
				<FormattedMessage defaultMessage="There has been an error. Please reload the page to try again." />
			</Content>

			<Icon src={cloudImg} alt="" width="124" height="124" aria-hidden />
			<LinkButton onClick={reloadPage} data-testid="reload-button">
				<FormattedMessage defaultMessage="Reload page" />
			</LinkButton>
		</Container>
	);
};

export const GenericErrorBoundary: FCWithChildren = ({ children }) => (
	<ErrorBoundary
		FallbackComponent={GenericErrorMessage}
		onError={(error, errorInfo) => {
			logger.error({ error, errorInfo });
		}}
	>
		{children}
	</ErrorBoundary>
);
